require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.date.to-iso-string");

require("core-js/modules/es6.date.to-json");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.map");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.create");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

module.exports = function (e) {
  var t = {};

  function r(n) {
    if (t[n]) return t[n].exports;
    var o = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e["default"];
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 0);
}([function (e, t, r) {
  "use strict";

  r.r(t);
  var n = {};
  r.r(n), r.d(n, "ServiceError", function () {
    return d;
  }), r.d(n, "init", function () {
    return l;
  }), r.d(n, "request", function () {
    return v;
  }), r.d(n, "formatArrayParam", function () {
    return j;
  }), r.d(n, "formatDate", function () {
    return S;
  });
  var o = {};
  r.r(o), r.d(o, "getApiData", function () {
    return P;
  }), r.d(o, "getPreview", function () {
    return x;
  }), r.d(o, "getSendSaveData", function () {
    return T;
  }), r.d(o, "getVisualize", function () {
    return _;
  });
  var a = {
    host: "daymet.ornl.gov",
    schemes: ["https"],
    basePath: "/single-pixel",
    contentTypes: [],
    accepts: ["application/json"]
  };

  function u(e) {
    return (u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function c(e, t) {
    return !t || "object" !== u(t) && "function" != typeof t ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : t;
  }

  function i(e) {
    var t = "function" == typeof Map ? new Map() : void 0;
    return (i = function i(e) {
      if (null === e || (r = e, -1 === Function.toString.call(r).indexOf("[native code]"))) return e;
      var r;
      if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");

      if (void 0 !== t) {
        if (t.has(e)) return t.get(e);
        t.set(e, n);
      }

      function n() {
        return s(e, arguments, p(this).constructor);
      }

      return n.prototype = Object.create(e.prototype, {
        constructor: {
          value: n,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), f(n, e);
    })(e);
  }

  function s(e, t, r) {
    return (s = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }() ? Reflect.construct : function (e, t, r) {
      var n = [null];
      n.push.apply(n, t);
      var o = new (Function.bind.apply(e, n))();
      return r && f(o, r.prototype), o;
    }).apply(null, arguments);
  }

  function f(e, t) {
    return (f = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function p(e) {
    return (p = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  var d = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), c(this, p(t).apply(this, arguments));
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && f(e, t);
    }(t, i(Error)), t;
  }(),
      y = {};

  function l(e) {
    y = e;
  }

  function v(e, t, r) {
    return r || (r = 1), function (e, t, r) {
      if (e.security && r.getAuthorization) return e.security.reduce(function (n, o) {
        return n.then(function (n) {
          var a = t.securityDefinitions[o.id];
          return r.getAuthorization(o, a, e).then(function (e) {
            return n[o.id] = e, n;
          });
        });
      }, Promise.resolve({}));
      return Promise.resolve({});
    }(e, a, y).then(function (n) {
      t = t || {};
      var o,
          u = (o = a, y.url || "".concat(o.schemes[0] || "https", "://").concat(o.host).concat(o.basePath)),
          c = {
        parameters: t,
        baseUrl: u
      };
      y.processRequest && (c = y.processRequest(e, c));

      var i = function (e, t, r, n) {
        var o = function (e, t) {
          var r = ["header", "path", "query", "formData"].reduce(function (e, t) {
            return e[t] = function (e) {
              return Object.keys(e || {}).reduce(function (t, r) {
                var n = e[r];
                return void 0 !== n && (t[r] = h(n)), t;
              }, {});
            }(e[t]), e;
          }, t);
          r.header || (r.header = {});
          return r;
        }(0, r);

        o = function (e, t, r) {
          return Object.keys(t).forEach(function (n) {
            var o = t[n],
                a = r.securityDefinitions[n];

            switch (a.type) {
              case "basic":
                var u = "".concat(o.username, ":").concat(o.password),
                    c = "undefined" != typeof window && window.btoa ? window.btoa(u) : new Buffer(u).toString("base64");
                e.header[m("Authorization")] = "Basic ".concat(c);
                break;

              case "oauth2":
                e.header[m("Authorization")] = "Bearer ".concat(o.token);
                break;

              case "apiKey":
                if ("header" === a["in"]) e.header[m(a.name)] = o.apiKey;else {
                  if ("query" !== a["in"]) throw new Error("Api key must be in header or query not '".concat(a["in"], "'"));
                  e.query[a.name] = o.apiKey;
                }
                break;

              default:
                throw new Error("Security definition type '".concat(a.type, "' not supported"));
            }
          }), e;
        }(o, n, a);

        var u = function (e, t, r, n) {
          var o = "".concat(t).concat(e.path);
          r.path && (o = Object.keys(r.path).reduce(function (e, t) {
            return e.replace("{".concat(t, "}"), r.path[t]);
          }, o));

          var a = function (e) {
            var t = Object.keys(e || {});
            return t.length ? "?" + t.map(function (t) {
              return {
                name: t,
                value: e[t]
              };
            }).reduce(function (e, t) {
              return Array.isArray(t.value) ? e.concat(t.value) : (e.push(b(t.name, t.value)), e);
            }, []).sort().join("&") : "";
          }(r.query);

          return o + a;
        }(e, t, o),
            c = function (e, t) {
          var r,
              n,
              o = {};
          r = e.accepts && e.accepts.length ? e.accepts : a.accepts && a.accepts.length ? a.accepts : ["application/json"];
          o.Accept = r.join(", "), e.contentTypes && e.contentTypes[0] ? n = e.contentTypes[0] : a.contentTypes && a.contentTypes[0] && (n = a.contentTypes[0]);
          n && (o["Content-Type"] = n);
          return Object.assign(o, t.header);
        }(e, o),
            i = function (e) {
          if (e) {
            if (e.body) return e.body;
            var t = Object.keys(e)[0];
            if (t) return e[t];
          }

          return;
        }(r.body);

        return {
          method: e.method,
          url: u,
          headers: c,
          body: i
        };
      }(e, c.baseUrl, c.parameters, n);

      return function (e) {
        var t = {
          compress: !0,
          method: (e.method || "get").toUpperCase(),
          headers: e.headers,
          body: e.body ? JSON.stringify(e.body) : void 0
        };

        if (y.fetchOptions) {
          var r = y.fetchOptions,
              n = r.headers ? Object.assign(t.headers, r.headers) : t.headers;
          (t = Object.assign({}, t, r)).headers = n;
        }

        return fetch(e.url, t);
      }(i).then(function (e) {
        return function (e, t, r, n) {
          var o,
              a = t.ok ? g : w,
              u = t.headers.get("content-type") || "";
          o = 204 === t.status ? Promise.resolve() : ~u.indexOf("json") ? t.json() : ~u.indexOf("octet-stream") ? t.blob() : ~u.indexOf("text") ? t.text() : Promise.resolve();
          return o.then(function (e) {
            return a(t, e, n);
          }).then(function (t) {
            return n.processResponse ? n.processResponse(e, t, r) : Promise.resolve({
              res: t
            });
          });
        }(i, e, r, y);
      }, function (e) {
        return function (e, t) {
          var r = y.processError,
              n = {
            res: {
              raw: {},
              data: t,
              error: !0
            }
          };
          return Promise.resolve(r ? r(e, n) : n);
        }(i, e);
      }).then(function (n) {
        return n.retry ? v(e, t, r + 1) : n.res;
      });
    });
  }

  function h(e) {
    return null == e ? "" : e instanceof Date ? e.toJSON() : Array.isArray(e) ? e : e.toString();
  }

  function b(e, t) {
    var r = h(t);
    return r && "string" == typeof r ? "".concat(e, "=").concat(encodeURIComponent(r)) : e;
  }

  function m(e) {
    return y.authorizationHeader && "authorization" === e.toLowerCase() ? y.authorizationHeader : e;
  }

  function g(e, t, r) {
    return {
      raw: e,
      data: t
    };
  }

  function w(e, t, r) {
    if (r.formatServiceError) t = r.formatServiceError(e, t);else {
      var n = new d();
      t ? ("string" == typeof t ? n.message = t : (t.message && (n.message = t.message), t.body ? n.body = t.body : n.body = t), t.code && (n.code = t.code)) : n.message = e.statusText, n.status = e.status, t = n;
    }
    return {
      raw: e,
      data: t,
      error: !0
    };
  }

  var O = {
    csv: ",",
    multi: "&",
    pipes: "|",
    ssv: " ",
    tsv: "\t"
  };

  function j(e, t, r) {
    if (e) {
      if ("multi" === t) return e.map(function (e) {
        return b(r, e);
      });
      var n = O[t];
      if (!n) throw new Error("Invalid collection format '".concat(t, "'"));
      return e.map(h).join(n);
    }
  }

  function S(e, t) {
    if (e) {
      var r = e.toISOString();
      return "date" === t ? r.split("T")[0] : r;
    }
  }

  function P(e, t, r, n) {
    n || (n = {});
    var o = {
      query: {
        lat: e,
        lon: t,
        vars: j(n.vars, "csv", "vars"),
        years: j(n.years, "csv", "years"),
        start: S(n.start, "date"),
        end: S(n.end, "date"),
        format: r
      }
    };
    return v(A, o);
  }

  function x(e, t, r, n) {
    n || (n = {});
    var o = {
      query: {
        lat: e,
        lon: t,
        vars: j(n.vars, "csv", "vars"),
        years: j(n.years, "csv", "years"),
        start: S(n.start, "date"),
        end: S(n.end, "date"),
        format: r
      }
    };
    return v(E, o);
  }

  function T(e, t, r, n) {
    n || (n = {});
    var o = {
      query: {
        lat: e,
        lon: t,
        vars: j(n.vars, "csv", "vars"),
        years: j(n.years, "csv", "years"),
        start: S(n.start, "date"),
        end: S(n.end, "date"),
        format: r
      }
    };
    return v(q, o);
  }

  function _(e, t, r, n) {
    n || (n = {});
    var o = {
      query: {
        lat: e,
        lon: t,
        vars: j(n.vars, "csv", "vars"),
        years: j(n.years, "csv", "years"),
        start: S(n.start, "date"),
        end: S(n.end, "date"),
        format: r
      }
    };
    return v(k, o);
  }

  var A = {
    path: "/api/data",
    method: "get"
  },
      E = {
    path: "/preview",
    method: "get"
  },
      q = {
    path: "/send/saveData",
    method: "get"
  },
      k = {
    path: "/visualize",
    method: "get"
  };
  r.d(t, "Api", function () {
    return o;
  }), r.d(t, "Gateway", function () {
    return n;
  });
}]);